import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'
import { padding } from 'styled-system'

export const AuditContent = styled.article.attrs({
  py: 'l',
})`
  ${padding}
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const AuditIndexContainer = styled.div`
  min-width: 900px;
  max-width: 1024px;
  overflow: hidden;
  min-height: 90vh;
`
export const AddAuditButton = styled.div`
  display: flex;
  justify-content: right;
`

export const MagentaP = styled.p`
  color: ${palette.magenta[400]};
  text-wrap: nowrap;
`

export const StatusContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 140px;
`

export const AuditIndexGridContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 24px 0px 16px;
  margin-top: 16px;
  overflow: auto;
  min-height: 0;
  max-height: calc(100vh - 200px);
  flex-grow: 0;
  flex-basis: min-content;
`
